<template>
  <v-container
    id="painelMagisEntrega"
    fluid
    tag="section"
    class="px-3 pt-0"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <dashboard-filtro-datas
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :status-primeiro="enablePrimeiroDiaStatus"
            :status-ultimo="enableUltimoDiaStatus"
            :motoristas="enableMotoristas"
            :status-entregas="enableStatusEntrega"
            :ordem-entrega-exibicao="enableEntregaExibicao"
            :campos-ordenacao="enableCamposOrdenacao"
            :ordem-ordenacao="enableOrdemEntrega"
            :data-inicial-preenchida="false"
            :data-final-preenchida="false"
            :texto-data-inicial="'Data Cadastro Inicial'"
            :texto-data-final="'Data Cadastro Final'"
            :url="link"
          />
          <v-row v-if="enableBtnPrint">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              class="text-left"
            >
              <v-btn
                class="col-6 col-sm-6 col-md-2 col-lg-2"
                small
                :color="corPrimaria"
                dark
                :loading="loadingPrint"
                @click="imprimir()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Imprimir
              </v-btn>
            </v-col>
          </v-row>
          <v-row id="tableMagisEntrega">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto ma-0 pa-0"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Relatório Magis Entrega
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip top>
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('418')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <dashboard-table-entrega />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row id="rankingMotoristaEntrega">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Ranking Motorista x Entregas
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip top>
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('419')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <dashboard-ranking-entrega />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardFluxoCaixa',
    emits: ['updateFormMagisEntrega', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashboardTableEntrega: () => import('../../components/magisEntrega/TableDadosEntrega'),
      DashboardRankingEntrega: () => import('../../components/magisEntrega/RankingEntrega'),
    },
    mixins: [utils],
    data: () => ({
      attrs: '',
      on: '',
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      usuarioIdentificado: false,
      paginaEnable: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enablePrimeiroDiaStatus: true,
      enableUltimoDiaStatus: true,
      enableEmpresa: true,
      enableMotoristas: true,
      enableStatusEntrega: true,
      enableEntregaExibicao: true,
      enableCamposOrdenacao: true,
      enableOrdemEntrega: true,
      link: window.location.href,
      permissaoMagisEntrega: '',
      select: [],
      codigo: 0,
      orientacao: [],
      codigoId: ['409', '410'],
      textoTableMagisEntrega: '',
      textoRankingEntrega: '',
      dynamicPaddingMagisEntrega: '',
      enableBtnPrint: false,
      loadingTableMagisEntrega: false,
      error: '',
      imprimindo: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dataInicialStatus: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinalStatus: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      motorista: [],
      statusEntrega: [],
      selectOrdem: [],
      selectOpcaoOrdenacao: [],
      selectOrientacaoOrdem: [],
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)

      eventEmit.$on('exibir-dados-ordenacao-entrega', this.handleDadosEntrega)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      eventEmit.$off('exibir-dados-ordenacao-entrega', this.handleDadosEntrega)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Magis Entrega')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.mobile = (window.innerWidth < 600)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingMagisEntrega = 'padding-right: 107rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingMagisEntrega = 'padding-right: 70rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 680) {
          this.dynamicPaddingMagisEntrega = 'padding-right: 5rem !important'
        } else if (window.innerWidth > 681 && window.innerWidth < 1080) {
          this.dynamicPaddingMagisEntrega = 'padding-right: 24rem !important'
        } else {
          this.dynamicPaddingMagisEntrega = 'padding-right: 70rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor, linhasProducao, primeiroDiaStatus, dataFinalStatus, motorista, statusEntrega, selectOrdem, selectOpcaoOrdenacao, selectOrientacaoOrdem) {
        this.dataInicial = primeiroDia
        this.dataFinal = dataFinal
        this.dataInicialStatus = primeiroDiaStatus
        this.dataFinalStatus = dataFinalStatus
        this.motorista = motorista
        this.statusEntrega = statusEntrega
        this.selectOrdem = selectOrdem
        this.selectOpcaoOrdenacao = selectOpcaoOrdenacao
        this.selectOrientacaoOrdem = selectOrientacaoOrdem ?? []

        localStorage.setItem('dataInicial', primeiroDia)
        localStorage.setItem('dataFinal', dataFinal)

        this.updateDados()
      },

      handleDadosEntrega (enableFiltroOrdenacao) {
        this.enableOrdemEntrega = enableFiltroOrdenacao
      },

      updateDados () {
        eventEmit.$emit('update-form-magis-entrega', this.dataInicial, this.dataFinal, this.dataInicialStatus, this.dataFinalStatus, this.motorista, this.statusEntrega, this.selectOrdem, this.selectOpcaoOrdenacao, this.selectOrientacaoOrdem)
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

   @media screen and (min-width: 1380px) and (max-width: 1800px) {
  }

  @media screen
  and (min-width: 1801px) {
  }
</style>

<style lang="sass">
  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

</style>
